import { useHistory } from 'react-router';
import { useState, ChangeEvent } from 'react';
import { useLoaderState, useHelpModalState } from 'react-commons';
import { useTranslation } from 'react-i18next';
import { useGlobalState } from '../../../state/persistence';
import { useGetLegalInsurances, useStyles } from '../../Shared';

const useLegalInsurance = (nextUrls: string[] | undefined) => {
  const { t } = useTranslation('legal_insurance');
  const history = useHistory();
  const { question, dispatchQuestion, appStore } = useGlobalState();
  const legalInsurances = useGetLegalInsurances();
  const [legalInsurance, setLegalInsurance] = useState<string>(question.legalInsurance || '');
  const { dispatchLoading } = useLoaderState();
  const { toggleHelpModal } = useHelpModalState();
  const [preResultUrl, unionUrl] = nextUrls || [];
  const onLegalInsuranceChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value === 'Bitte auswählen') setLegalInsurance('');
    else setLegalInsurance(value);
  };

  const onSubmit = async () => {
    dispatchLoading(true);

    dispatchQuestion('legalInsurance', legalInsurance);
    dispatchQuestion('hasUnionOptions', false);
    dispatchLoading(false);

    if (preResultUrl && unionUrl) {
      const selectedLegalInsurance = legalInsurances.find((l) => l.id === legalInsurance);
      if (selectedLegalInsurance && selectedLegalInsurance.options?.includes('union')) {
        history.push(unionUrl);
      } else {
        history.push(preResultUrl);
      }
    }
  };

  const onSkip = () => {
    dispatchQuestion('legalInsurance', '');
    if (preResultUrl) {
      history.push(preResultUrl);
    }
  };

  return {
    classes: useStyles(),
    t,
    toggleHelpModal,
    onLegalInsuranceChange,
    legalInsurance,
    legalInsurances,
    onSubmit,
    onSkip,
  };
};

export default useLegalInsurance;
